import { CaseData } from "@/cms/models";
import { getCaseClassification, isLand } from "@/utils/helper";
import PlotOfLandPropertyFacts from "./PlotOfLandPropertyFacts";
import DefaultPropertyFacts from "./DefaultPropertyFacts";

const PropertyFacts: React.FC<{
  caseData: CaseData;
  showPrice: boolean;
  subdomain?: string;
  showStandardFinancing?: boolean;
}> = ({ caseData, showPrice, subdomain, showStandardFinancing }) => {
  const classifications = getCaseClassification(caseData);
  return isLand(classifications) ? (
    <PlotOfLandPropertyFacts caseData={caseData} />
  ) : (
    <DefaultPropertyFacts
      caseData={caseData}
      showPrice={showPrice}
      subdomain={subdomain}
      showStandardFinancing={showStandardFinancing}
    />
  );
};

export default PropertyFacts;
